<template>
  <div class="bottom-bar">
    <div class="button all-products">
      <a href="#menu">
        <div>
          <AllProducts/>
        </div>
        כל המוצרים
      </a>
    </div>
    <div class="button sale-products">
      <router-link to="/מבצעים">
        <div>
          <SalesCategory/>
        </div>
        מבצעים
      </router-link>
    </div>
    <CartHead/>
    <div class="button sale-products">
      <router-link :to="{name : 'history'}">
        <div>
          <RecoverOrder/>
        </div>
        {{!this.$store.state.hasOrderEdit ? 'שחזור הזמנה': 'עריכת הזמנה'}}
      </router-link>
    </div>
    <div class="button sale-products">
      <router-link :to="parseLink(costumerServiceLink)">
        <div>
          <NeedHelp/>
        </div>
        צריכים עזרה?
      </router-link>
    </div>
  </div>
</template>

<script>
import CartHead from "../../components/Cart/CartHead";

import AllProducts from "../../assets/img/all-products.svg"
import NeedHelp from "../../assets/img/need-help.svg"
import RecoverOrder from "../../assets/img/recover-order.svg"
import SalesCategory from "../../assets/img/sales-category.svg"

export default {
  data() {
    return {
      wpData: wpData,
      costumerServiceLink: wpData.globalOptions.pages.service,
    };
  },
  methods: {
    parseLink(link) {
      return link.replace(wpData.home_url, "");
    },
  },
  components: {
    CartHead,
    AllProducts,
    NeedHelp,
    RecoverOrder,
    SalesCategory
  },
};
</script>

<style lang="scss">
.bottom-bar {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 4;
  background: #fff;
  border-radius: 30px 30px 0 0;
  box-shadow: 0 0 20px -5px #545454;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  padding: 0 10px;

  & > div {
    flex: 0 1 20%;
    text-align: center;

    &.button {
      z-index: 1;
    }

    a {
      color: #213519;
      font-weight: bold;
    }

  }

  .head_cart {
    position: relative;

    a {
      position: static;
      height: 77px;
      width: 77px;
      margin-top: -25px;

      svg {
        width: 31px;
        margin-top: 3px;
      }

      .cart_num {
        top: 14px!important;
        left: 0;
        right: 0;
        width: auto;
      }
    }
  }
}
</style>